import { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import type {
  Props as ButtonProps,
  Color,
} from '#src/atoms/buttons/Button/index.tsx';
import { Button } from '#src/atoms/buttons/Button/index.tsx';
import { useIsLoggedIn } from '#src/hooks/auth/useIsLoggedIn.ts';
import { useToggleSubscription } from '#src/hooks/subscriptions/useToggleSubscription.ts';
import { useLoggedCallback } from '#src/hooks/useLoggedCallback.ts';
import { fantasy, glossary } from '#src/lib/glossary.ts';
import { isType } from '#src/lib/gql/index.ts';

interface Props extends Omit<
  ButtonProps,
  'onChange' | 'classes' | 'onClick' | 'size'
> {
  currentUserSubscription: { slug: string } | null | undefined;
  subscribable: { __typename: string; slug: string };
  onChange?: (value: boolean) => void;
  onClick?: (value: boolean) => void;
}

const Root = styled(Button)`
  &.stroke {
    background-color: white;
  }
`;

export const FollowButton = (props: Props) => {
  const {
    currentUserSubscription,
    subscribable,
    onChange,
    onClick,
    className,
    ...rest
  } = props;
  const isLoggedIn = useIsLoggedIn();
  const [hover, setHover] = useState(false);
  const toggleSubscription = useToggleSubscription(
    currentUserSubscription,
    subscribable
  );
  const callback = () => {
    onChange?.(!currentUserSubscription);
    toggleSubscription();
  };
  const loggedToggleSubscription = useLoggedCallback(callback, true, true);

  let btnColor: Color = 'secondary';
  if (currentUserSubscription && hover) {
    btnColor = 'destructive';
  } else if (currentUserSubscription) {
    btnColor = 'quaternary';
  }

  return (
    <Root
      onClick={e => {
        onClick?.(!currentUserSubscription);
        loggedToggleSubscription(e);
      }}
      className={className}
      color={btnColor}
      size="medium"
      onMouseEnter={() => {
        if (currentUserSubscription) setHover(true);
      }}
      onMouseLeave={() => {
        if (currentUserSubscription) setHover(false);
      }}
      blur
      {...rest}
    >
      {isLoggedIn ? (
        <span>
          {isType(subscribable, 'User') ? (
            <>
              {currentUserSubscription ? (
                <FormattedMessage
                  {...(hover ? fantasy.removeCircle : fantasy.inCircle)}
                />
              ) : (
                <FormattedMessage {...fantasy.addCircle} />
              )}
            </>
          ) : (
            <>
              {currentUserSubscription ? (
                <FormattedMessage
                  {...(hover ? glossary.unfollow : glossary.following)}
                />
              ) : (
                <FormattedMessage {...glossary.follow} />
              )}
            </>
          )}
        </span>
      ) : (
        <span>
          <FormattedMessage {...glossary.playNow} />
        </span>
      )}
    </Root>
  );
};
